export default __webpack_public_path__ + "static/media/google.2220f21c.svg";